export const contentTermsLoading =  ({store})  => store.contentTermsReducer.loading;

export const contentTermsError =  ({store})  => store.contentTermsReducer.error;

export const contentTermsData =  ({store})  => store.contentTermsReducer.data;